// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-kb-src-pages-404-js": () => import("./../../../node_modules/gatsby-theme-kb/src/pages/404.js" /* webpackChunkName: "component---node-modules-gatsby-theme-kb-src-pages-404-js" */),
  "component---node-modules-gatsby-theme-kb-src-templates-topic-js": () => import("./../../../node_modules/gatsby-theme-kb/src/templates/Topic.js" /* webpackChunkName: "component---node-modules-gatsby-theme-kb-src-templates-topic-js" */)
}

